import React, { useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
// import team from "./views/team";
import clsx from "clsx";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import GlobalApi from "./Global";
import useDimensions from "./Global/useDimensions";
import refresh_token from "./Global/refresh_token";
import "./App.css";
import Drawer from "@material-ui/core/Drawer";
import Badge from "@material-ui/core/Badge";
import NotificationsIcon from "@material-ui/icons/Notifications";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Grid from "@material-ui/core/Grid";
import MenuIcon from "@material-ui/icons/Menu";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Colors from "./Global/colors";
import Alert from "@material-ui/lab/Alert";
import dashboard from "./Assets/dashboard.png";
import template from "./Assets/Template.png";
import inspection from "./Assets/Inspection.png";
import schedule from "./Assets/schedule.png";
import buy from "./Assets/buy.png";
// import help from "./Assets/Help.png";
import teamG from "./Assets/TeamG.png";
import siteG from "./Assets/siteG.png";
import Executive from "./Assets/executive_dashboard.png";
// import reportG from "./Assets/report.png";
import companyG from "./Assets/Company_icon.png";
import CancelIcon from "@material-ui/icons/Cancel";
import reportG from "./Assets/report.png";
import action from "./Assets/action.png";
import workflow from "./Assets/workflow.png";
import more from "./Assets/more.png";
import analytics from "./Assets/analytics.png";
import logo from "./Assets/Logo.png";
import logo2 from "./Assets/urAuditsFull.png";
import activity from "./Assets/activity.png";
import help from "./Assets/Help.png";
import Popover from "@material-ui/core/Popover";
import swal from "@sweetalert/with-react";


//Redux
import { addUser } from "./Redux/Actions/userAction";
import { addCompany } from "./Redux/Actions/companyAction";
import { addCompanyArr } from "./Redux/Actions/companyArrActions";
import { addTeam } from "./Redux/Actions/teamAction";
import { updateNotification } from "./Redux/Actions/notificationAction";
import {
  forReviewApprovals,
  forReviewActions,
} from "./Redux/Actions/routeTrackingAction";
import { removeCompanyArr } from "./Redux/Actions/companyArrActions";
import { removeCompany } from "./Redux/Actions/companyAction";
import { clearNotification } from "./Redux/Actions/notificationAction";
import { openSideBar } from "./Redux/Actions/sidebarAction";
import { setLanguage } from "./Redux/Actions/languageAction";

//Socket+
import { io } from "socket.io-client";
import "./SideNav.css";
import { useSelector, useDispatch } from "react-redux";

//translation
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

const drawerWidth = 140;

const socket = io(GlobalApi.replace("api", ""));

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    padding: "0px",
    backgroundColor: "#adcbf6",
  },
  root2: {
    display: "flex",
    backgroundColor: "#adcbf6",
    height: "100vh",
  },

  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  drawer: {
    width: "80px",
    flexShrink: 0,
    border: "none",
    height: "100vh",
    overflow: "hidden",
  },
  drawerPaper: {
    width: "80px",
    backgroundColor: "Colors.globalColor8",
    border: "none",
    height: "100vh",
    margin: "0px",
    overflow: "hidden",
  },
  drawer2: {
    width: "80px",
    flexShrink: 0,
    border: "none",
    height: "100vh",
    overflow: "hidden",
  },
  drawerPaper2: {
    width: "80px",
    backgroundColor: "Colors.globalColor8",
    border: "none",
    height: "100vh",
    overflow: "hidden",
  },
  drawerNew: {
    width: drawerWidth,
    flexShrink: 0,
    border: "none",
    whiteSpace: "nowrap",
  },
  drawerOpenNew: {
    width: 210,
    border: "none",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerCloseNew: {
    border: "none",
    width: 70,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    [theme.breakpoints.up("sm")]: {
      width: "70px",
    },
  },

  hide: {
    display: "none",
  },
  toolbar: theme.mixins.toolbar,

  drawerContainer: {
    backgroundColor: Colors.globalColor8,
    // borderTopLeftRadius: language == "en" ? "30px" : "0px",
    // borderBottomLeftRadius: language == "en" ? "30px" : "0px",
    // borderTopRightRadius: language == "en" ? "0px" : "30px",
    // borderBottomRightRadius: language == "en" ? "0px" : "30px",
  },
  drawerHeader: {
    // display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    width: "100%",
    marginTop: 80,
    backgroundColor: "white",
    padding: theme.spacing(2),
    overflow: "scroll",
  },
  logoBox: {
    height: "150px",
    backgroundColor: "white",
  },

  listItem: {
    display: "flex",
    flexDirection: "column",
    height: "auto",
    justifyContent: "center",
    textAlign: "center",
    color: "white",
    width: "100px",
  },
  selector: {
    width: "200px",
    borderRadius: 0,
    padding: 5,
  },
  large: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    background: `linear-gradient(#01defe, #1459f3)`,
  },
}));

function SideBar(props) {
  const currentLanguage = Cookies.get("i18next") || "en";
  const { t, i18n } = useTranslation();
  const language = useSelector((state) => state.languageReducer.language);
  console.log("PROPS IN SIDEBAR>>>>>>>", props);
  const classes = useStyles();
  const theme = useTheme();
  const temporaryDrawerRef = useRef(null);
  const permanentDrawerRef = useRef(null);
  const history = useHistory();
  const [consentModal, setConsentModal] = React.useState(false);
  const { height, width } = useDimensions();
  const [user, setUser] = React.useState(null);
  const fileSizeRedux = useSelector((state) => state.reducer.fileSize);
  const dispatch = useDispatch();
  const [packageExpired, setPackageExpired] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const [anchorEl3, setAnchorEl3] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [topArrow, setTopArrow] = React.useState(false);
  const [bottomArrow, setBottomArrow] = React.useState(true);
  const [navHeight, setNavHeight] = React.useState(0);
  const [isMobile, setMobile] = React.useState(false);
  const [version, setVersion] = React.useState("");
  const [currentCompany, setCurrentCompany] = React.useState([]);
  const [companies, setCompanies] = React.useState([]);
  const [currentCompanyName, setCurrentCompanyName] = React.useState("");
  const [teams, setTeams] = React.useState([]);
  const [Token, setToken] = React.useState("");
  const [drawerState, setDrawerState] = React.useState(false);
  const [notifications, setNotifications] = React.useState(0);
  const [topNotifications, setTopNotifications] = React.useState([]);
  const [state, setState] = React.useState(false);
  let [currentFileSize, setCurrentFileSize] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [openTemp, setOpenTemp] = React.useState(false);
  const [dataLimit, setDataLimit] = React.useState(0);
  const [drawerHold, setDrawerHold] = React.useState(false);
  let [packageDetails, setPackageDetails] = React.useState({});
  const [licenseDetails, setLicenseDetails] = React.useState({});
  const location = useLocation();



  React.useLayoutEffect(
    () => {
      nav.current && setNavHeight(nav.current.clientHeight);
    },
    [isMobile]
  );

  useEffect(
    () => {
      if (language == "ar") {
        document.body.dir = "rtl";
      } else {
        document.body.dir = "ltr";
      }
    },
    [language]
  );

  console.log("PROPS IN LANGUAGE>>>>>>>", language);

  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLanguageChange = (value) => {
    handleClose3();
    i18n.changeLanguage(value);
    dispatch(setLanguage(value));
  };

  console.log("openTemp", openTemp);

  const open2 = Boolean(anchorEl);
  const open3 = Boolean(anchorEl2);
  const open4 = Boolean(anchorEl3);
  const id = open2 ? "simple-popover" : undefined;
  const id2 = open3 ? "simple-popover" : undefined;
  const id3 = open4 ? "simple-popover" : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick2 = (event) => {
    if (notifications > 1) {
      setAnchorEl2(event.currentTarget);
    } else {
      history.push("/notifications");
    }
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const checkIsMobile = () => (window.innerWidth < 960 ? true : false);
  if (typeof window !== "undefined") {
    window.onresize = () =>
      isMobile !== checkIsMobile && setMobile(checkIsMobile);
  }

  const handleClick3 = (event) => {
    setAnchorEl3(event.currentTarget);
  };

  const handleClose3 = () => {
    setAnchorEl3(null);
  };

  const nav = React.useRef();

  const testDAta = useSelector((state) => state);

  console.log(
    "fileSizeRedux____________________________________________",
    testDAta
  );

  async function logout() {
    swal({
      text: t("Are you sure You Want to Logout?"),
      icon: "warning",
      buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        console.log("DELETE 1 CALLED");
        // window.Intercom("shutdown");
        let localstorage = localStorage.getItem("UserData");

        let data = JSON.parse(localstorage);
        fetch(GlobalApi + "/DeviceRecord/delete_device_record", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + data.token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            device_record_id: data.device_id,
          }),
        })
          .then((res) => res.json())
          .then(async (resJson) => {
            console.log("DELETE RESPONSE IF DEVICE API", resJson);

            console.log("all Dispatches Called");
            dispatch(clearNotification());
            dispatch(removeCompany());
            dispatch(removeCompanyArr());
            // dispatch(removeIndustryArr());
            await history.replace("/signin");
            localStorage.clear();
            localStorage.clearItem("persist:root");
          })
          .catch((error) => console.log("error", error));
      } else {
        console.log("Canceled");
      }
    });
  }

  let userData = useSelector((state) => state.userReducer.user);
  let NotificationCount = useSelector(
    (state) => state.notificationReducer.count
  );
  console.log("userData", userData);

  let data = useSelector((state) => state.companyArrReducer.company);

  let team = useSelector((state) => state.teamReducer.team);

  useEffect(
    () => {
      if (data) {
        setCompanies(data);
      }
    },
    [data]
  );

  let data2 = useSelector((state) => state.companyReducer.company);
  let company = useSelector((state) => state.companyReducer.company);
  useEffect(
    () => {
      if (data2) {
        setCurrentCompany(data2);
        setCurrentCompanyName(data2.id);
        getTeamData(data2.id);
        getNotifications();
      }
    },
    [data2]
  );

  const getTeamData = (company) => {
    if (localStorage.getItem("UserData") === null) {
      return <Redirect to={"/signin"} />;
    }
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let tokenNew = data.token;

    let params = { company_id: company };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_users?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + tokenNew,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg == "success") {
          console.log("RESPONSE TEAM >>>>", response);
          dispatch(addTeam(response));
          setTeams(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  };

  console.log("teama Data ***********", teams);

  const globalState = {
    text: "foo",
  };

  React.useEffect(
    () => {
      getCompaniesDetail();
      getLicenseDetails();
      getOrganization();
      toggleTempDrawer(false);
    },
    [location.pathname, history]
  );

  async function getCompaniesDetail() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let tokenNew = data?.token;

    let params1 = {
      user_id: data?.user_id,
    };
    let query1 = Object.keys(params1)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params1[k]))
      .join("&");

    let getCompanies = await fetch(
      GlobalApi + "/Company/get_user_companies?" + query1,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + tokenNew,
          "Content-Type": "application/json",
        },
      }
    );
    let companiesJson = await getCompanies.json();
    if (companiesJson.msg === "success") {
      //find index of company in companies array
      let index = companiesJson?.companies.findIndex(
        (filterDate) => filterDate?.id === company?.id
      );

      console.log("AAAAAAA", companiesJson.companies);

      if (index < 0) {
        dispatch(addCompany(companiesJson.companies[0]));
      } else {
        dispatch(addCompany(companiesJson.companies[index]));
      }

      dispatch(addCompanyArr(companiesJson.companies));
    }
  }

  // console.log("location.pathname",location.pathname)
  async function getOrganization() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      organization_id: data?.organization_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Organization/get_organization?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response>>>>>>>>>>>>>>>>", response);
        if (
          response.data.status == "deactivated" &&
          (location.pathname !== "/signin" ||
            location.pathname !== "/signup" ||
            location.pathname !== "/forgotpassword" ||
            location.pathname !== "/blocked")
        ) {
          history.replace("/blocked");
        }
      })
      .catch((error) => console.log(error.message));
  }

  const daysTillPackageExpires = (data) => {
    const today = new Date();
    const expiryDate = new Date(data);
    console.log("today", today);
    console.log("expiryDate", expiryDate);
    const diffTime = Math.abs(expiryDate - today);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  async function getLicenseDetails() {
    let localstorage = localStorage.getItem("UserData");
    var localData = JSON.parse(localstorage);
    let token = localData?.token;

    if (localData == null) {
      return;
    }
    let package_inquiry = {
      user_id: localData.user_id,
      organization_id: localData.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");

    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    let reqJson = await req.json();
    console.log("Calling Get License ", reqJson);
    setLicenseDetails(reqJson.package.license);

    if (
      reqJson?.package?.license?.status === "expired" ||
      reqJson?.package?.license?.status === "deactive"
    ) {
      if (
        location.pathname.substring(0, 15) !== "/update_package" &&
        location.pathname.substring(0, 8) !== "/billing" &&
        location.pathname.substring(0, 12) !== "/lisence_add" &&
        location.pathname.substring(0, 14) !== "/lisence_renew" &&
        location.pathname.substring(0, 16) !== "/billing/history"
      ) {
        history.replace("/billing");
      }
    } else {
      setPackageDetails(reqJson.package);

      if (reqJson?.package?.curr_user?.role !== userData?.role) {
        let newData = {
          ...userData,
          role: reqJson?.package?.curr_user?.role,
        };
        dispatch(addUser(newData));
        localStorage.setItem("UserData", JSON.stringify(newData));
      }
    }
  }

  // for Intercom
  React.useEffect(() => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    window.Intercom("update", {
      app_id: "g7aqg8ty",
      name: `${data?.first_name} ${data?.last_name}`,
      email: data?.email,
    });
  }, []);
  // for Intercom

  React.useEffect(() => {
    let localstorage = localStorage.getItem("UserData");
    var userData = JSON.parse(localstorage);
    // fetchUsers();

    getFileSize();
    console.log(
      "SOCKET______________________________________________________",
      socket.on
    );

    socket.on("Notification", (data) => {
      console.log("Notification Data from socket", data);
      if (data?.user_id === userData?.user_id) {
        console.log("User Matched LogedIn");
        dispatch(updateNotification(company?.id));
        if (data.type === "Inspection Review") {
          dispatch(forReviewApprovals(true));
        }
        if (data.type === "Action Assigned") {
          dispatch(forReviewActions(true));
        }
      } else {
        console.log("User NOt Matched LogedIn");
      }
    });
  }, []);

  function getFileSize() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      user_id: data?.user_id,
      organization_id: data?.organization_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/ConfigFileSize/get_all_file_sizes_user?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          console.log("SET_FILE_SIZE", response);
          setDataLimit(parseInt(response.percent));
          dispatch({ type: "SET_FILE_SIZE", payload: response.data });
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getNotifications() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      user_id: data?.user_id,
      company_id: company?.id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Notification/get_all_notifications?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response from notifications", response);
        if (response.status === "Success") {
          let count = [];
          console.log(response.data);

          response.data.forEach((item) => {
            if (!item.is_read) {
              count.push(item);
            }
          });

          let slicedArray = count.slice(0, 3);
          // console.log("REsponse From NOTIFICATIONS>>>>>>>",slicedArray)
          setTopNotifications(slicedArray);
          setNotifications(count.length);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getNotifications();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  const handleScroll = (e) => {
    if (e.target.scrollHeight > 10) {
      setTopArrow(true);
    }

    try {
      temporaryDrawerRef.current.scrollTop = e?.target?.scrollTop;
      permanentDrawerRef.current.scrollTop = e?.target?.scrollTop;
    } catch (error) {
      console.log(error);
    }

    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    const top = e.target.scrollTop == 0;
    if (bottom) {
      setBottomArrow(false);
    }
    if (top) {
      setBottomArrow(true);
      setTopArrow(false);
    }
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerState(open);
  };

  const toggleTempDrawer = (state) => {
    if (!open) {
      setOpenTemp(state);
    }
  };

  let dropdownItems = () => {
    let localstorage = localStorage.getItem("UserData");
    let data = JSON.parse(localstorage);
    if (
      packageDetails?.package?.title == "Enterprise" ||
      packageDetails?.package?.title == "Free"
    ) {
      if (data?.role == "inspector") {
        return [
          {
            title: <>{t("Workspace")}</>,
            link: "/",
            image: dashboard,
          },
          {
            title: <>{t("Template")}</>,
            link: "/template",
            image: template,
          },
          {
            title: <>{t("Schedule")}</>,
            link: "/schedule",
            image: schedule,
          },
          {
            title: <>{t("Inspection")}</>,
            link: "/inspection",
            image: inspection,
          },

          {
            title: <>{t("Action")}</>,
            link: "/action",
            image: action,
          },

          {
            title: <>{t("Report")}</>,
            link: "/template-report-list",
            image: reportG,
            backgroundColor: "#e7f3ff",
          },
        ];
      } else if (data?.role == "management") {
        return [
          {
            title: <>{t("Workspace")}</>,
            link: "/",
            image: dashboard,
          },

          {
            title: <>{t("Workflow")}</>,
            link: "/workflow",
            image: workflow,
          },
          {
            title: <>{t("Analytics")}</>,
            link: "/analytics/dashboard",
            image: analytics,
            nav: false,
          },
          {
            title: <>{t("Executive Dashboard")}</>,
            link: "/executive-dashboard",
            image: Executive,
            nav: false,
          },
          {
            title: <>{t("Packages")}</>,
            link: "/update_package",
            image: buy,
            backgroundColor: "#e7f3ff",
          },
        ];
      } else {
        return [
          {
            title: <>{t("Workspace")}</>,
            link: "/",
            image: dashboard,
          },
          {
            title: <>{t("Template")}</>,
            link: "/template",
            image: template,
          },
          {
            title: <>{t("Schedule")}</>,
            link: "/schedule",
            image: schedule,
          },
          {
            title: <>{t("Inspection")}</>,
            link: "/inspection",
            image: inspection,
          },

          {
            title: <>{t("Action")}</>,
            link: "/action",
            image: action,
          },
          {
            title: <>{t("Workflow")}</>,
            link: "/workflow",
            image: workflow,
          },
          {
            title: <>{t("Analytics")}</>,
            link: "/analytics/dashboard",
            image: analytics,
            nav: false,
          },
          {
            title: <>{t("Executive Dashboard")}</>,
            link: "/executive-dashboard",
            image: Executive,
            nav: false,
          },
          {
            title: <>{t("Report")}</>,
            link: "/template-report-list",
            image: reportG,
            backgroundColor: "#e7f3ff",
          },
          {
            title: <>{t("Packages")}</>,
            link: "/update_package",
            image: buy,
            backgroundColor: "#e7f3ff",
          },
          {
            title: <>{t("Company")}</>,
            link: "/company",
            image: companyG,
          },
          {
            title: <>{t("Team")}</>,
            link: "/team/user/list",
            image: teamG,
          },
          {
            title: <>{t("Sites")}</>,
            link: "/sites",
            image: siteG,
          },
        ];
      }
    } else {
      return [
        {
          title: <>{t("Workspace")}</>,
          link: "/",
          image: dashboard,
        },
        {
          title: <>{t("Template")}</>,
          link: "/template",
          image: template,
        },
        {
          title: <>{t("Schedule")}</>,
          link: "/schedule",
          image: schedule,
        },
        {
          title: <>{t("Inspection")}</>,
          link: "/inspection",
          image: inspection,
        },

        {
          title: <>{t("Action")}</>,
          link: "/action",
          image: action,
        },
        {
          title: <>{t("Workflow")}</>,
          link: "/workflow",
          image: workflow,
        },
        {
          title: <>{t("Analytics")}</>,
          link: "/analytics/dashboard",
          image: analytics,
          nav: false,
        },
        {
          title: <>{t("Executive Dashboard")}</>,
          link: "/executive-dashboard",
          image: Executive,
          nav: false,
        },
        {
          title: <>{t("Report")}</>,
          link: "/template-report-list",
          image: reportG,
          backgroundColor: "#e7f3ff",
        },
        {
          title: <>{t("Packages")}</>,
          link: "/update_package",
          image: buy,
          backgroundColor: "#e7f3ff",
        },
        {
          title: <>{t("Company")}</>,
          link: "/company",
          image: companyG,
        },
        {
          title: <>{t("Team")}</>,
          link: "/team/user/list",
          image: teamG,
        },
        {
          title: <>{t("Sites")}</>,
          link: "/sites",
          image: siteG,
        },
      ];
    }
  };

  if (localStorage.getItem("UserData") === null) {
    return <Redirect to={"/signin"} />;
  } else {
    return (
      <>
        {window.innerWidth > 500 && (
          <div className={classes.root}>
            <Drawer
              onMouseEnter={() => toggleTempDrawer(true)}
              // onMouseLeave={() => toggleTempDrawer(false)}
              className={clsx(classes.drawerNew, {
                [classes.drawerOpenNew]: open,
                [classes.drawerCloseNew]: !open,
              })}
              classes={{
                paper: clsx({
                  [classes.drawerOpenNew]: open,
                  [classes.drawerCloseNew]: !open,
                }),
              }}
              variant="permanent"
              style={{
                borderTopRightRadius: "30px",
                borderBottomLeftRadius: "30px",
                overflow: "hidden",
                zIndex: 2,
              }}
              anchor={language == "ar" ? "right" : "left"}
            >
              <div
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  padding: "8px 8px 8px 8px",
                  backgroundColor: "white",
                  height: "60px",
                }}
              >
                {!open ? (
                  <img
                    src={logo}
                    style={{
                      width: "50px",
                      backgroundColor: "white",
                      borderRadius: "100px",
                      boxShadow:
                        " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItem: "center",
                      padding: "10px",
                    }}
                  >
                    <img
                      src={logo2}
                      style={{
                        marginTop: "10px",
                        width: "80%",
                        backgroundColor: "white",
                      }}
                    />
                  </div>
                )}
              </div>
              <br />
              {/* {topArrow ? <span style={{ textAlign: "center" }}>
                  <img src={up} width={20} onClick={() => handleUp()} style={{ cursor: "pointer" }} />
                </span> : <br />} */}
              <div
                ref={permanentDrawerRef}
                onScroll={(e) => handleScroll(e)}
                className="sidebarList"
                id="scrollList"
                style={{
                  overflowY: "scroll",
                  marginTop: "7px",
                  marginBottom: "5px",
                  scrollBehavior: "smooth",
                }}
              >
                <ListCont packageDetails={packageDetails} />
              </div>
              {/* {bottomArrow && <span style={{ textAlign: "center" }}>
                  <img src={down} width={20} onClick={() => handleDown()} style={{ cursor: "pointer" }} />
                </span>} */}
            </Drawer>

            <Drawer
              className="temporaryDrawer"
              anchor={language == "ar" ? "right" : "left"}
              open={openTemp || drawerHold}
              onMouseOut={() => toggleTempDrawer(false)}
            >
              <div
                style={{
                  marginBottom: "7px",
                  textAlign: "center",
                  padding: "8px 8px 8px 8px",
                  backgroundColor: "white",
                  height: "62px",
                }}
              />
              <br />
              <div
                ref={temporaryDrawerRef}
                onScroll={(e) => handleScroll(e)}
                onMouseEnter={() => setDrawerHold(true)}
                onMouseLeave={() => setDrawerHold(false)}
                className="sidebarList"
                id="scrollList"
                style={{
                  overflowY: "scroll",
                  marginTop: "0px",
                  marginBottom: "5px",
                  scrollBehavior: "smooth",
                }}
              >
                <ListCont packageDetails={packageDetails} />
              </div>
            </Drawer>

            <div
              style={{
                width: "100%",
                height: "100vh",
                backgroundColor: "white",
                borderTopRightRadius: "0px",
                borderBottomRightRadius: "0px",
                overflow: "hidden",
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              }}
              onMouseOver={() => toggleTempDrawer(false)}
            >
              <div
                className="mainAreaBox"
                style={{
                  width: "100%",
                  height: "100vh",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  borderTopLeftRadius: language !== "ar" ? "30px" : "0px",
                  borderBottomLeftRadius: language !== "ar" ? "30px" : "0px",
                  borderTopRightRadius: language !== "ar" ? "0px" : "30px",
                  borderBottomRightRadius: language !== "ar" ? "0px" : "30px",
                  backgroundColor: Colors.globalColor9,
                }}
                onMouseOver={() => toggleTempDrawer(false)}
              >
                <div className="header">
                  <Grid
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    style={{
                      justifyContent: "space-between",
                      padding: "2px 30px",
                      backgroundImage: "linear-gradient(#01defe, #1459f3)",
                      borderBottom: "1px solid #dadada",
                    }}
                  >
                    <Grid item>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item>
                          <IconButton
                            color="white"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            className={clsx(classes.menuButton)}
                          >
                            <MenuIcon style={{ color: "white" }} />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item>
                      <Grid container spacing={2} alignItems="center">
                        {/* <Grid item>
                          <TranslateIcon
                            style={{
                              color: "white",
                              marginTop: "8px",
                              fontSize: "24px",
                            }}
                            onClick={handleClick3}
                          />

                          <Popover
                            id={id3}
                            open={open4}
                            anchorEl={anchorEl3}
                            onClose={handleClose3}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "center",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "center",
                            }}
                          >
                            <div style={{ padding: "0px" }}>
                              <Grid
                                style={{ maxWidth: "200px", textAlign: "left" }}
                                spacing={0}
                              >
                                <Grid
                                  item
                                  xs={12}
                                  style={{
                                    minWidth: "100px",
                                    textAlign: "left",
                                    backgroundColor:
                                      language == "en" && "#eaf7fe",
                                  }}
                                >
                                  <div
                                    onClick={() => handleLanguageChange("en")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      cursor: "pointer",
                                      alignItems: "center",
                                      padding: "10px 20px",
                                    }}
                                  >
                                    <img
                                      src={English}
                                      width={20}
                                      height={14}
                                      style={{ margin: "0px 10px 0px 10px" }}
                                    />
                                    <p
                                      style={{
                                        fontSize: 10,
                                        margin: 0,
                                        fontWeight: "bold",
                                        color: Colors.globalColor8,
                                        textTransform: "uppercase",
                                        textAlign: "center",
                                        display: "inline-block",
                                      }}
                                    >
                                      English
                                    </p>
                                  </div>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  style={{
                                    minWidth: "100px",
                                    textAlign: "left",
                                    backgroundColor:
                                      language == "ar" && "#eaf7fe",
                                  }}
                                >
                                  <div
                                    onClick={() => handleLanguageChange("ar")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      cursor: "pointer",
                                      alignItems: "center",
                                      padding: "10px 20px",
                                    }}
                                  >
                                    <img
                                      src={Arabic}
                                      width={20}
                                      height={14}
                                      style={{ margin: "0px 10px 0px 10px" }}
                                    />
                                    <p
                                      style={{
                                        fontSize: 10,
                                        margin: 0,
                                        fontWeight: "bold",
                                        color: Colors.globalColor8,
                                        textTransform: "uppercase",
                                        textAlign: "center",
                                        display: "inline-block",
                                      }}
                                    >
                                      Arabic
                                    </p>
                                  </div>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  style={{
                                    minWidth: "100px",
                                    textAlign: "left",
                                    backgroundColor:
                                      language == "fr" && "#eaf7fe",
                                  }}
                                >
                                  <div
                                    onClick={() => handleLanguageChange("fr")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      cursor: "pointer",
                                      alignItems: "center",
                                      padding: "10px 20px",
                                    }}
                                  >
                                    <img
                                      src={French}
                                      width={20}
                                      height={14}
                                      style={{ margin: "0px 10px 0px 10px" }}
                                    />
                                    <p
                                      style={{
                                        fontSize: 10,
                                        margin: 0,
                                        fontWeight: "bold",
                                        color: Colors.globalColor8,
                                        textTransform: "uppercase",
                                        textAlign: "center",
                                        display: "inline-block",
                                      }}
                                    >
                                      French
                                    </p>
                                  </div>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  style={{
                                    minWidth: "100px",
                                    textAlign: "left",
                                    backgroundColor:
                                      language == "gr" && "#eaf7fe",
                                  }}
                                >
                                  <div
                                    onClick={() => handleLanguageChange("gr")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      cursor: "pointer",
                                      alignItems: "center",
                                      padding: "10px 20px",
                                    }}
                                  >
                                    <img
                                      src={German}
                                      width={20}
                                      height={14}
                                      style={{ margin: "0px 10px 0px 10px" }}
                                    />
                                    <p
                                      style={{
                                        fontSize: 10,
                                        margin: 0,
                                        fontWeight: "bold",
                                        color: Colors.globalColor8,
                                        textTransform: "uppercase",
                                        textAlign: "center",
                                        display: "inline-block",
                                      }}
                                    >
                                      German
                                    </p>
                                  </div>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  style={{
                                    minWidth: "100px",
                                    textAlign: "left",
                                    backgroundColor:
                                      language == "it" && "#eaf7fe",
                                  }}
                                >
                                  <div
                                    onClick={() => handleLanguageChange("it")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      cursor: "pointer",
                                      alignItems: "center",
                                      padding: "10px 20px",
                                    }}
                                  >
                                    <img
                                      src={Italian}
                                      width={20}
                                      height={14}
                                      style={{ margin: "0px 10px 0px 10px" }}
                                    />
                                    <p
                                      style={{
                                        fontSize: 10,
                                        margin: 0,
                                        fontWeight: "bold",
                                        color: Colors.globalColor8,
                                        textTransform: "uppercase",
                                        textAlign: "center",
                                        display: "inline-block",
                                      }}
                                    >
                                      Italian
                                    </p>
                                  </div>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  style={{
                                    minWidth: "100px",
                                    textAlign: "left",
                                    backgroundColor:
                                      language == "dn" && "#eaf7fe",
                                  }}
                                >
                                  <div
                                    onClick={() => handleLanguageChange("dn")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      cursor: "pointer",
                                      alignItems: "center",
                                      padding: "10px 20px",
                                    }}
                                  >
                                    <img
                                      src={Danish}
                                      width={20}
                                      height={14}
                                      style={{ margin: "0px 10px 0px 10px" }}
                                    />
                                    <p
                                      style={{
                                        fontSize: 10,
                                        margin: 0,
                                        fontWeight: "bold",
                                        color: Colors.globalColor8,
                                        textTransform: "uppercase",
                                        textAlign: "center",
                                        display: "inline-block",
                                      }}
                                    >
                                      Danish
                                    </p>
                                  </div>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  style={{
                                    minWidth: "100px",
                                    textAlign: "left",
                                    backgroundColor:
                                      language == "fi" && "#eaf7fe",
                                  }}
                                >
                                  <div
                                    onClick={() => handleLanguageChange("fi")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      cursor: "pointer",
                                      alignItems: "center",
                                      padding: "10px 20px",
                                    }}
                                  >
                                    <img
                                      src={Finnish}
                                      width={20}
                                      height={14}
                                      style={{
                                        margin: "0px 10px 0px 10px",
                                        border: "1px solid #dadada",
                                      }}
                                    />
                                    <p
                                      style={{
                                        fontSize: 10,
                                        margin: 0,
                                        fontWeight: "bold",
                                        color: Colors.globalColor8,
                                        textTransform: "uppercase",
                                        textAlign: "center",
                                        display: "inline-block",
                                      }}
                                    >
                                      Finnish
                                    </p>
                                  </div>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  style={{
                                    minWidth: "100px",
                                    textAlign: "left",
                                    backgroundColor:
                                      language == "no" && "#eaf7fe",
                                  }}
                                >
                                  <div
                                    onClick={() => handleLanguageChange("no")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      cursor: "pointer",
                                      alignItems: "center",
                                      padding: "10px 20px",
                                    }}
                                  >
                                    <img
                                      src={Norwegian}
                                      width={20}
                                      height={14}
                                      style={{ margin: "0px 10px 0px 10px" }}
                                    />
                                    <p
                                      style={{
                                        fontSize: 10,
                                        margin: 0,
                                        fontWeight: "bold",
                                        color: Colors.globalColor8,
                                        textTransform: "uppercase",
                                        textAlign: "center",
                                        display: "inline-block",
                                      }}
                                    >
                                      Norwegian
                                    </p>
                                  </div>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  style={{
                                    minWidth: "100px",
                                    textAlign: "left",
                                    backgroundColor:
                                      language == "ro" && "#eaf7fe",
                                  }}
                                >
                                  <div
                                    onClick={() => handleLanguageChange("ro")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      cursor: "pointer",
                                      alignItems: "center",
                                      padding: "10px 20px",
                                    }}
                                  >
                                    <img
                                      src={Romanian}
                                      width={20}
                                      height={14}
                                      style={{ margin: "0px 10px 0px 10px" }}
                                    />
                                    <p
                                      style={{
                                        fontSize: 10,
                                        margin: 0,
                                        fontWeight: "bold",
                                        color: Colors.globalColor8,
                                        textTransform: "uppercase",
                                        textAlign: "center",
                                        display: "inline-block",
                                      }}
                                    >
                                      Romansh
                                    </p>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                          </Popover>
                        </Grid> */}
                        <Grid item>
                          <Badge
                            badgeContent={NotificationCount}
                            style={{ cursor: "pointer" }}
                            color="error"
                            onClick={handleClick2}
                          >
                            <NotificationsIcon style={{ color: "white" }} />
                          </Badge>
                          <Popover
                            id={id2}
                            open={open3}
                            anchorEl={anchorEl2}
                            onClose={handleClose2}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "center",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "center",
                            }}
                          >
                            <div style={{ padding: "0px" }}>
                              <Grid style={{ maxWidth: "200px" }}>
                                {topNotifications.length > 0 &&
                                  topNotifications.map((item, index) => {
                                    return (
                                      <Grid
                                        item
                                        xs={12}
                                        style={{
                                          padding: "5px 10px",
                                          borderBottom: "1px solid #dadada",
                                        }}
                                      >
                                        <p
                                          className="label2"
                                          style={{
                                            fontSize: 12,
                                            fontWeight: "bold",
                                            color: Colors.globalColor8,
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {item.title}
                                        </p>
                                        <p
                                          className="label2"
                                          style={{
                                            fontWeight: "normal",
                                            margin: "auto",
                                            fontSize: 10,
                                            color: "grey",
                                            textTransform: "capitalized",
                                          }}
                                        >
                                          {item?.details.slice(0, 100) +
                                            (item?.details?.length > 100
                                              ? "..."
                                              : "")}
                                        </p>
                                      </Grid>
                                    );
                                  })}
                                <Grid item xs={12}>
                                  <p
                                    className="label2"
                                    style={{
                                      fontSize: 12,
                                      marginBottom: 20,
                                      fontWeight: "bold",
                                      color: Colors.globalColor8,
                                      textTransform: "uppercase",
                                      textAlign: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      history.push("/notifications")
                                    }
                                  >
                                    Read More
                                  </p>
                                </Grid>
                              </Grid>
                            </div>
                          </Popover>
                        </Grid>
                        <Grid
                          item
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                          }}
                        >
                          <Grid item>
                            {userData.avatar == null ? (
                              <div
                                style={{
                                  width: 35,
                                  height: 35,
                                  borderRadius: "50px",
                                  backgroundColor: Colors.globalColor9,
                                  display: "flex",
                                  justifyContent: "center",
                                  margin: 1,
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={handleClick}
                              >
                                <p
                                  className="poppins"
                                  style={{
                                    fontWeight: "bolder",
                                    fontSize: "12px",
                                    color: Colors.globalColor8,
                                  }}
                                >
                                  {userData &&
                                    userData.first_name
                                      .substring(0, 1)
                                      .toUpperCase()
                                      .concat(
                                        userData.last_name
                                          .substring(0, 1)
                                          .toUpperCase()
                                      )}
                                </p>
                              </div>
                            ) : (
                              <div
                                style={{
                                  width: 35,
                                  height: 35,
                                  borderRadius: "50px",
                                  color: "#043077",
                                  display: "flex",
                                  justifyContent: "center",
                                  margin: 1,
                                  alignItems: "center",
                                  cursor: "pointer",
                                  backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                    userData.avatar
                                  })`,
                                  backgroundSize: "cover",
                                }}
                                onClick={handleClick}
                              />
                            )}

                            <Popover
                              id={id}
                              open={open2}
                              anchorEl={anchorEl}
                              onClose={handleClose}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "center",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "center",
                              }}
                            >
                              <div style={{ padding: "10px 20px" }}>
                                <Grid container>
                                  <Grid item>
                                    <Grid
                                      container
                                      spacing={2}
                                      alignItems="center"
                                    >
                                      <Grid
                                        item
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignContent: "center",
                                        }}
                                      >
                                        <Grid item>
                                          {userData.avatar == null ? (
                                            <div
                                              style={{
                                                width: 50,
                                                height: 50,
                                                borderRadius: "50px",
                                                backgroundColor:
                                                  Colors.globalColor8,
                                                display: "flex",
                                                justifyContent: "center",
                                                margin: 1,
                                                alignItems: "center",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <p
                                                className="poppins"
                                                style={{
                                                  fontWeight: "bolder",
                                                  fontSize: "14px",
                                                  color: Colors.globalColor9,
                                                }}
                                              >
                                                {userData &&
                                                  userData.first_name
                                                    .substring(0, 1)
                                                    .toUpperCase()
                                                    .concat(
                                                      userData.last_name
                                                        .substring(0, 1)
                                                        .toUpperCase()
                                                    )}
                                              </p>
                                            </div>
                                          ) : (
                                            <div
                                              style={{
                                                width: 50,
                                                height: 50,
                                                borderRadius: "50px",
                                                color: "#043077",
                                                display: "flex",
                                                justifyContent: "center",
                                                margin: 1,
                                                alignItems: "center",
                                                cursor: "pointer",
                                                backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                                  userData.avatar
                                                })`,
                                                backgroundSize: "cover",
                                              }}
                                            />
                                          )}
                                        </Grid>
                                        {/* <Grid item>
                          <div>
                            <p
                              style={{
                                marginBottom: 0,
                                marginTop: 2,
                                color: "white",
                                fontWeight: "bold",
                                fontSize: "16px",
                              }}
                              className="UserName"
                            >
                              {userData.first_name} {userData.last_name}
                            </p>
                          </div>
                        </Grid> */}
                                        {/* <img
                            src={power}
                            width={30}
                            onClick={() => logout()}
                            style={{ cursor: "pointer" }}
                            className="logoutBtn"
                          /> */}
                                      </Grid>
                                      <Grid item>
                                        <div>
                                          <p
                                            style={{
                                              marginBottom: 0,
                                              marginTop: 2,
                                              fontWeight: "bold",
                                              fontSize: "14px",
                                            }}
                                            className="UserName"
                                          >
                                            {userData.first_name}{" "}
                                            {userData.last_name}
                                          </p>
                                          <p
                                            style={{
                                              marginBottom: 0,
                                              marginTop: 2,
                                              color: Colors.globalColor8,
                                              fontSize: "12px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              history.push("/account")
                                            }
                                          >
                                            {t("Account Settings")}
                                          </p>
                                          {packageDetails?.package?.title ==
                                          "Enterprise" ? (
                                            <>
                                              {" "}
                                              {userData?.role !== "inspector" &&
                                                userData?.role !==
                                                  "management" && (
                                                  <>
                                                    {userData.super_admin && (
                                                      <p
                                                        style={{
                                                          marginBottom: 0,
                                                          marginTop: 2,
                                                          color:
                                                            Colors.globalColor8,
                                                          fontSize: "12px",
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          history.push(
                                                            "/billing"
                                                          )
                                                        }
                                                      >
                                                        {t("License & Billing")}
                                                      </p>
                                                    )}
                                                  </>
                                                )}
                                            </>
                                          ) : (
                                            <p
                                              style={{
                                                marginBottom: 0,
                                                marginTop: 2,
                                                color: Colors.globalColor8,
                                                fontSize: "12px",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                history.push("/billing")
                                              }
                                            >
                                              {t("License & Billing")}
                                            </p>
                                          )}

                                          <p
                                            style={{
                                              marginBottom: 0,
                                              marginTop: 2,
                                              color: Colors.globalColor8,
                                              fontSize: "12px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              setAnchorEl(null);
                                              logout();
                                            }}
                                          >
                                            {t("Logout")}
                                          </p>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </div>
                            </Popover>
                          </Grid>
                          {/* <Grid item>
                          <div>
                            <p
                              style={{
                                marginBottom: 0,
                                marginTop: 2,
                                color: "white",
                                fontWeight: "bold",
                                fontSize: "16px",
                              }}
                              className="UserName"
                            >
                              {userData.first_name} {userData.last_name}
                            </p>
                          </div>
                        </Grid> */}
                          {/* <img
                            src={power}
                            width={30}
                            onClick={() => logout()}
                            style={{ cursor: "pointer" }}
                            className="logoutBtn"
                          /> */}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>

                {dataLimit >= 95 && (
                  <Alert variant="filled" severity="error">
                    You have reached 95% of your package limit - please contact{" "}
                    <a
                      href="https://www.uraudits.com/"
                      target="_blank"
                      style={{
                        color: "white",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      customer support
                    </a>{" "}
                    to upgrade your package
                  </Alert>
                )}

                {packageDetails?.package?.title !== "Free" &&
                  daysTillPackageExpires(licenseDetails?.expiry_date) <= 10 &&
                  licenseDetails?.status !== "grace_time" && (
                    <Alert variant="filled" severity="error">
                      Your License will Expire on{" "}
                      {moment(licenseDetails?.expiry_date).format(
                        "DD MMMM YYYY"
                      )}{" "}
                      - please renew your License or Package
                    </Alert>
                  )}

                {packageDetails?.package?.title !== "Free" &&
                  licenseDetails?.status == "grace_time" && (
                    <Alert variant="filled" severity="error">
                      Your License has Expired on{" "}
                      {moment(licenseDetails?.expiry_date).format(
                        "DD MMMM YYYY"
                      )}{" "}
                      - you have a grace period of{" "}
                      {packageDetails?.package?.title === "Small / Medium"
                        ? "15"
                        : "30"}{" "}
                      Days. Please Renew your license or purchase a package
                    </Alert>
                  )}

                <div
                  style={{
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "white",
                  }}
                >
                  {props.children}
                </div>
              </div>
            </div>
          </div>
        )}

        {window.innerWidth <= 500 && (
          <div className={classes.root2}>
            {/* Drawer */}
            <SwipeableDrawer
              anchor={"top"}
              open={drawerState}
              onClose={toggleDrawer(false)}
              onOpen={toggleDrawer(true)}
            >
              <div style={{ height: "100vh", overflowY: "scroll" }}>
                <div
                  className={classes.drawerHeader}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0px 10px",
                  }}
                >
                  <img src={logo2} alt="logo" width={180} />
                  <IconButton onClick={toggleDrawer(false)}>
                    <CancelIcon style={{ color: Colors.globalColor8 }} />
                  </IconButton>
                </div>
                <Divider />
                <List>
                  {dropdownItems().map((item, index) => {
                    if (packageDetails?.package?.title !== "Enterprise") {
                      if (packageDetails?.package?.title === "Free") {
                        if (
                          item.title !== <>{t("Executive Dashboard")}</> &&
                          item.title !== <>{t("Analytics")}</>
                        ) {
                          return (
                            <>
                              <ListItem
                                button
                                onClick={() => {
                                  setDrawerState(false);
                                  history.push(item.link);
                                }}
                                key={index}
                                style={{
                                  backgroundColor:
                                    location?.pathname == item.link
                                      ? "#e8f2fe"
                                      : "transparent",
                                }}
                              >
                                <ListItemIcon>
                                  <img src={item.image} width={20} />
                                </ListItemIcon>

                                <ListItemText
                                  className={
                                    language == "ar"
                                      ? "sidebarText2"
                                      : "sidebarText"
                                  }
                                  primary={item.title}
                                />
                              </ListItem>
                              <hr
                                style={{
                                  borderTop: "1px solid #e5ecef",
                                  borderBottom: "none",
                                  marginTop: 0,
                                  width: "100%",
                                  marginBottom: 0,
                                }}
                              />
                            </>
                          );
                        }
                      } else {
                        if (item.title !== <>{t("Executive Dashboard")}</>) {
                          return (
                            <>
                              <ListItem
                                button
                                onClick={() => {
                                  setDrawerState(false);
                                  history.push(item.link);
                                }}
                                key={index}
                                style={{
                                  backgroundColor:
                                    location?.pathname == item.link
                                      ? "#e8f2fe"
                                      : "transparent",
                                }}
                              >
                                <ListItemIcon>
                                  <img src={item.image} width={20} />
                                </ListItemIcon>

                                <ListItemText
                                  className={
                                    language == "ar"
                                      ? "sidebarText2"
                                      : "sidebarText"
                                  }
                                  primary={item.title}
                                />
                              </ListItem>
                              <hr
                                style={{
                                  borderTop: "1px solid #e5ecef",
                                  borderBottom: "none",
                                  marginTop: 0,
                                  width: "100%",
                                  marginBottom: 0,
                                }}
                              />
                            </>
                          );
                        }
                      }
                    } else if (packageDetails?.package?.title == "Enterprise") {
                      return (
                        <>
                          <ListItem
                            button
                            onClick={() => {
                              setDrawerState(false);
                              history.push(item.link);
                            }}
                            key={index}
                            style={{
                              backgroundColor:
                                location?.pathname == item.link
                                  ? "#e8f2fe"
                                  : "transparent",
                            }}
                          >
                            <ListItemIcon>
                              <img src={item.image} width={20} />
                            </ListItemIcon>

                            <ListItemText
                              className={
                                language == "ar"
                                  ? "sidebarText2"
                                  : "sidebarText"
                              }
                              primary={item.title}
                            />
                          </ListItem>
                          <hr
                            style={{
                              borderTop: "1px solid #e5ecef",
                              borderBottom: "none",
                              marginTop: 0,
                              width: "100%",
                              marginBottom: 0,
                            }}
                          />
                        </>
                      );
                    }
                  })}
                </List>
              </div>
            </SwipeableDrawer>

            {/* Main Component */}
            <div
              style={{
                width: "100%",
                backgroundColor: "white",
                overflow: "hidden",
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              }}
            >
              <div
                className="mainAreaBox"
                style={{
                  width: "100%",
                  height: "100vh",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  borderTopLeftRadius: "0px",
                  backgroundColor: Colors.globalColor9,
                }}
              >
                {/* ====for Mobile */}
                <div className="header">
                  <Grid
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    style={{
                      justifyContent: "space-between",
                      padding: "7px 30px",
                      backgroundImage: "linear-gradient(#01defe, #1459f3)",
                      borderBottom: "1px solid #dadada",
                    }}
                  >
                    <Grid item>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item>
                          <IconButton
                            aria-label="delete"
                            onClick={toggleDrawer(true)}
                            style={{ padding: "0px" }}
                          >
                            <MenuIcon style={{ color: "white" }} />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item>
                          <Badge
                            badgeContent={NotificationCount}
                            style={{ cursor: "pointer" }}
                            color="error"
                            onClick={handleClick2}
                          >
                            <NotificationsIcon style={{ color: "white" }} />
                          </Badge>
                          <Popover
                            id={id2}
                            open={open3}
                            anchorEl={anchorEl2}
                            onClose={handleClose2}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "center",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "center",
                            }}
                          >
                            <div style={{ padding: "0px" }}>
                              <Grid style={{ maxWidth: "200px" }}>
                                {topNotifications.length > 0 &&
                                  topNotifications.map((item, index) => {
                                    return (
                                      <Grid
                                        item
                                        xs={12}
                                        style={{
                                          padding: "5px 10px",
                                          borderBottom: "1px solid #dadada",
                                        }}
                                      >
                                        <p
                                          className="label2"
                                          style={{
                                            fontSize: 12,
                                            fontWeight: "bold",
                                            color: Colors.globalColor8,
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {item.title}
                                        </p>
                                        <p
                                          className="label2"
                                          style={{
                                            fontWeight: "normal",
                                            margin: "auto",
                                            fontSize: 10,
                                            color: "grey",
                                            textTransform: "capitalized",
                                          }}
                                        >
                                          {item?.details.slice(0, 100) +
                                            (item?.details?.length > 100
                                              ? "..."
                                              : "")}
                                        </p>
                                      </Grid>
                                    );
                                  })}
                                <Grid item xs={12}>
                                  <p
                                    className="label2"
                                    style={{
                                      fontSize: 12,
                                      marginBottom: 20,
                                      fontWeight: "bold",
                                      color: Colors.globalColor8,
                                      textTransform: "uppercase",
                                      textAlign: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      history.push("/notifications")
                                    }
                                  >
                                    Read More
                                  </p>
                                </Grid>
                              </Grid>
                            </div>
                          </Popover>
                        </Grid>
                        <Grid
                          item
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                          }}
                        >
                          <Grid item>
                            {userData.avatar == null ? (
                              <div
                                style={{
                                  width: 35,
                                  height: 35,
                                  borderRadius: "50px",
                                  backgroundColor: Colors.globalColor9,
                                  display: "flex",
                                  justifyContent: "center",
                                  margin: 1,
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={handleClick}
                              >
                                <p
                                  className="poppins"
                                  style={{
                                    fontWeight: "bolder",
                                    fontSize: "12px",
                                    color: Colors.globalColor8,
                                  }}
                                >
                                  {userData &&
                                    userData.first_name
                                      .substring(0, 1)
                                      .toUpperCase()
                                      .concat(
                                        userData.last_name
                                          .substring(0, 1)
                                          .toUpperCase()
                                      )}
                                </p>
                              </div>
                            ) : (
                              <div
                                style={{
                                  width: 35,
                                  height: 35,
                                  borderRadius: "50px",
                                  color: "#043077",
                                  display: "flex",
                                  justifyContent: "center",
                                  margin: 1,
                                  alignItems: "center",
                                  cursor: "pointer",
                                  backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                    userData.avatar
                                  })`,
                                  backgroundSize: "cover",
                                }}
                                onClick={handleClick}
                              />
                            )}

                            <Popover
                              id={id}
                              open={open2}
                              anchorEl={anchorEl}
                              onClose={handleClose}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "center",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "center",
                              }}
                            >
                              <div style={{ padding: "10px 20px" }}>
                                <Grid container>
                                  <Grid item>
                                    <Grid
                                      container
                                      spacing={2}
                                      alignItems="center"
                                    >
                                      <Grid
                                        item
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignContent: "center",
                                        }}
                                      >
                                        <Grid item>
                                          {userData.avatar == null ? (
                                            <div
                                              style={{
                                                width: 50,
                                                height: 50,
                                                borderRadius: "50px",
                                                backgroundColor:
                                                  Colors.globalColor8,
                                                display: "flex",
                                                justifyContent: "center",
                                                margin: 1,
                                                alignItems: "center",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <p
                                                className="poppins"
                                                style={{
                                                  fontWeight: "bolder",
                                                  fontSize: "14px",
                                                  color: Colors.globalColor9,
                                                }}
                                              >
                                                {userData &&
                                                  userData.first_name
                                                    .substring(0, 1)
                                                    .toUpperCase()
                                                    .concat(
                                                      userData.last_name
                                                        .substring(0, 1)
                                                        .toUpperCase()
                                                    )}
                                              </p>
                                            </div>
                                          ) : (
                                            <div
                                              style={{
                                                width: 50,
                                                height: 50,
                                                borderRadius: "50px",
                                                color: "#043077",
                                                display: "flex",
                                                justifyContent: "center",
                                                margin: 1,
                                                alignItems: "center",
                                                cursor: "pointer",
                                                backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                                  userData.avatar
                                                })`,
                                                backgroundSize: "cover",
                                              }}
                                            />
                                          )}
                                        </Grid>
                                        {/* <Grid item>
                          <div>
                            <p
                              style={{
                                marginBottom: 0,
                                marginTop: 2,
                                color: "white",
                                fontWeight: "bold",
                                fontSize: "16px",
                              }}
                              className="UserName"
                            >
                              {userData.first_name} {userData.last_name}
                            </p>
                          </div>
                        </Grid> */}
                                        {/* <img
                            src={power}
                            width={30}
                            onClick={() => logout()}
                            style={{ cursor: "pointer" }}
                            className="logoutBtn"
                          /> */}
                                      </Grid>
                                      <Grid item>
                                        <div>
                                          <p
                                            style={{
                                              marginBottom: 0,
                                              marginTop: 2,
                                              fontWeight: "bold",
                                              fontSize: "14px",
                                            }}
                                            className="UserName"
                                          >
                                            {userData.first_name}{" "}
                                            {userData.last_name}
                                          </p>
                                          <p
                                            style={{
                                              marginBottom: 0,
                                              marginTop: 2,
                                              color: Colors.globalColor8,
                                              fontSize: "12px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              history.push("/account")
                                            }
                                          >
                                            {t("Account Settings")}
                                          </p>
                                          {userData.super_admin && (
                                            <p
                                              style={{
                                                marginBottom: 0,
                                                marginTop: 2,
                                                color: Colors.globalColor8,
                                                fontSize: "12px",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                history.push("/billing")
                                              }
                                            >
                                              {t("License & Billing")}
                                            </p>
                                          )}
                                          <p
                                            style={{
                                              marginBottom: 0,
                                              marginTop: 2,
                                              color: Colors.globalColor8,
                                              fontSize: "12px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              setAnchorEl(null);
                                              logout();
                                            }}
                                          >
                                            {t("Logout")}
                                          </p>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </div>
                            </Popover>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
                {dataLimit >= 95 && (
                  <Alert variant="filled" severity="error">
                    You have reached 95% of your package limit - please contact{" "}
                    <a
                      href="https://www.uraudits.com/"
                      target="_blank"
                      style={{
                        color: "white",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      customer support
                    </a>{" "}
                    to upgrade your package
                  </Alert>
                )}

                <div
                  style={{
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "white",
                  }}
                >
                  {props.children}
                </div>
              </div>
            </div>
          </div>
        )}
         {/* <LiveChatWidget license="16282938" /> */}
      </>
    );
  }
}

const ListCont = ({ packageDetails }) => {
  const currentLanguage = Cookies.get("i18next") || "en";
  const { t, i18n } = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  let localstorage = localStorage.getItem("UserData");
  let data = JSON.parse(localstorage);
  let userData = useSelector((state) => state.userReducer.user);
  let company = useSelector((state) => state.companyReducer.company);

  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [user, setUser] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showChild, setShowChild] = React.useState("");
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [version, setVersion] = React.useState("");

  const Nav_link_1 = () => {
    if (company?.role == "inspector") {
      return [
        {
          title: <>{t("Workspace")}</>,
          link: "/",
          image: dashboard,
          role: "inspector",
          package: "Enterprise",
        },
        {
          title: <>{t("Template")}</>,
          link: "/template",
          image: template,
        },
        {
          title: <>{t("Schedule")}</>,
          link: "/schedule",
          image: schedule,
        },
        {
          title: <>{t("Inspection")}</>,
          link: "/inspection",
          image: inspection,
        },
        {
          title: <>{t("Action")}</>,
          link: "/action",
          image: action,
        },
        {
          title: <>{t("Report")}</>,
          link: "/template-report-list",
          image: reportG,
          backgroundColor: "#e7f3ff",
        },
      ];
    } else if (company?.role == "management") {
      return [
        {
          title: <>{t("Workspace")}</>,
          link: "/",
          image: dashboard,
        },

        {
          title: <>{t("Workflow")}</>,
          link: "/workflow",
          image: workflow,
        },
        {
          title: <>{t("Analytics")}</>,
          link: "/analytics",
          image: analytics,
          nav: false,
        },
        {
          title: <>{t("Executive Dashboard")}</>,
          link: "/executive-dashboard",
          image: Executive,
        },
        {
          title: <>{t("Activity Log")}</>,
          link: "/activity_log",
          image: activity,
          backgroundColor: "#e7f3ff",
        },
      ];
    } else {
      return [
        {
          title: <>{t("Workspace")}</>,
          link: "/",
          image: dashboard,
        },
        {
          title: <>{t("Template")}</>,
          link: "/template",
          image: template,
        },
        {
          title: <>{t("Schedule")}</>,
          link: "/schedule",
          image: schedule,
        },
        {
          title: <>{t("Inspection")}</>,
          link: "/inspection",
          image: inspection,
        },
        {
          title: <>{t("Action")}</>,
          link: "/action",
          image: action,
        },
        {
          title: <>{t("Workflow")}</>,
          link: "/workflow",
          image: workflow,
        },
        {
          title: <>{t("Analytics")}</>,
          link: "/analytics",
          image: analytics,
          nav: false,
        },
        {
          title: <>{t("Executive Dashboard")}</>,
          link: "/executive-dashboard",
          image: Executive,
        },
        {
          title: <>{t("Report")}</>,
          link: "/template-report-list",
          image: reportG,
          backgroundColor: "#e7f3ff",
        },
        {
          title: <>{t("Activity Log")}</>,
          link: "/activity_log",
          image: activity,
          backgroundColor: "#e7f3ff",
        },
      ];
    }
  };

  const nav_link_2 = () => {
    return [
      {
        title: <>{t("Workspace")}</>,
        link: "/",
        image: dashboard,
      },
      {
        title: <>{t("Template")}</>,
        link: "/template",
        image: template,
      },
      {
        title: <>{t("Schedule")}</>,
        link: "/schedule",
        image: schedule,
      },
      {
        title: <>{t("Inspection")}</>,
        link: "/inspection",
        image: inspection,
      },
      {
        title: <>{t("Action")}</>,
        link: "/action",
        image: action,
      },
      {
        title: <>{t("Workflow")}</>,
        link: "/workflow",
        image: workflow,
      },
      {
        title: <>{t("Analytics")}</>,
        link: "/analytics",
        image: analytics,
        nav: false,
      },
      {
        title: <>{t("Executive Dashboard")}</>,
        link: "/executive-dashboard",
        image: Executive,
      },
      {
        title: <>{t("Report")}</>,
        link: "/template-report-list",
        image: reportG,
        backgroundColor: "#e7f3ff",
      },
    ];
  };

  if (user?.Organization?.status == "deactivated") {
    return <Redirect to={"/blocked"} />;
  }
  return (
    <List className="">
      {packageDetails?.package?.title == "Enterprise" ||
      packageDetails?.package?.title == "Free" ? (
        <>
          {Nav_link_1().map((item, index) => {
            console.log("PD", packageDetails);
            if (packageDetails?.package?.title !== "Enterprise") {
              if (packageDetails?.package?.title === "Free") {
                if (
                  item.title !== <>{t("Executive Dashboard")}</> &&
                  item.title !== <>{t("Analytics")}</>
                ) {
                  return (
                    <ListItem
                      className="linkBox nav-hover"
                      button
                      disableRipple={true}
                      disableTouchRipple={true}
                      key={item.title}
                      onClick={() => {
                        setShowChild(item.title);
                        history.push(item.link);
                      }}
                      style={{
                        paddingTop: "7px",
                        paddingBottom: "7px",
                        backgroundColor:
                          location?.pathname == item.link
                            ? "#e8f2fe"
                            : "transparent",
                        cursor: "pointer",
                      }}
                    >
                      <ListItemIcon>
                        <img
                          src={item.image}
                          width={10}
                          className="custom-img"
                        />
                      </ListItemIcon>

                      <ListItemText
                        className={
                          language == "ar" ? "sidebarText2" : "sidebarText"
                        }
                        style={{
                          textAlign: language != "ar" ? "left" : "right",
                          fontSize: language == "ar" ? "20px" : "14px",
                        }}
                        primary={item.title}
                      />
                    </ListItem>
                  );
                }
              } else {
                if (item.title !== <>{t("Executive Dashboard")}</>) {
                  return (
                    <ListItem
                      disableRipple={true}
                      disableTouchRipple={true}
                      className="linkBox nav-hover"
                      button
                      key={item.title}
                      onClick={() => {
                        setShowChild(item.title);
                        history.push(item.link);
                      }}
                      style={{
                        paddingTop: "7px",
                        paddingBottom: "7px",

                        backgroundColor:
                          location?.pathname == item.link
                            ? "#e8f2fe"
                            : "transparent",
                        cursor: "pointer",
                      }}
                    >
                      <ListItemIcon>
                        <img
                          src={item.image}
                          width={10}
                          className="custom-img"
                        />
                      </ListItemIcon>

                      <ListItemText
                        className={
                          language == "ar" ? "sidebarText2" : "sidebarText"
                        }
                        style={{
                          fontSize: language == "ar" ? "20px" : "14px",
                          textAlign: language != "ar" ? "left" : "right",
                        }}
                        primary={item.title}
                      />
                    </ListItem>
                  );
                }
              }
            } else if (packageDetails?.package?.title == "Enterprise") {
              return (
                <ListItem
                  button
                  disableRipple={true}
                  disableTouchRipple={true}
                  key={item.title}
                  className="linkBox nav-hover"
                  onClick={() => {
                    setShowChild(item.title);
                    history.push(item.link);
                  }}
                  style={{
                    paddingTop: "7px",
                    paddingBottom: "7px",

                    backgroundColor:
                      location?.pathname == item.link
                        ? "#e8f2fe"
                        : "transparent",
                    cursor: "pointer",
                  }}
                >
                  <ListItemIcon>
                    <img src={item.image} width={10} className="custom-img" />
                  </ListItemIcon>

                  <ListItemText
                    className={
                      language == "ar" ? "sidebarText2" : "sidebarText"
                    }
                    style={{
                      textAlign: language != "ar" ? "left" : "right",
                      fontSize: language == "ar" ? "20px" : "14px",
                    }}
                    primary={item.title}
                  />
                </ListItem>
              );
            }
          })}{" "}
        </>
      ) : (
        <>
          {nav_link_2().map((item, index) => {
            console.log("PD", packageDetails);
            if (packageDetails?.package?.title !== "Enterprise") {
              if (packageDetails?.package?.title === "Free") {
                if (
                  item.title !== <>{t("Executive Dashboard")}</> &&
                  item.title !== <>{t("Analytics")}</>
                ) {
                  return (
                    <ListItem
                      className="linkBox nav-hover"
                      button
                      disableRipple={true}
                      disableTouchRipple={true}
                      key={item.title}
                      onClick={() => {
                        setShowChild(item.title);
                        history.push(item.link);
                      }}
                      style={{
                        paddingTop: "7px",
                        paddingBottom: "7px",

                        backgroundColor:
                          location?.pathname == item.link
                            ? "#e8f2fe"
                            : "transparent",
                        cursor: "pointer",
                      }}
                    >
                      <ListItemIcon>
                        <img
                          src={item.image}
                          width={10}
                          className="custom-img"
                        />
                      </ListItemIcon>

                      <ListItemText
                        className={
                          language == "ar" ? "sidebarText2" : "sidebarText"
                        }
                        style={{
                          textAlign: language != "ar" ? "left" : "right",
                          fontSize: language == "ar" ? "20px" : "14px",
                        }}
                        primary={item.title}
                      />
                    </ListItem>
                  );
                }
              } else {
                if (item.title !== <>{t("Executive Dashboard")}</>) {
                  return (
                    <ListItem
                      className="linkBox nav-hover"
                      button
                      disableRipple={true}
                      disableTouchRipple={true}
                      key={item.title}
                      onClick={() => {
                        setShowChild(item.title);
                        history.push(item.link);
                      }}
                      style={{
                        paddingTop: "7px",
                        paddingBottom: "7px",

                        backgroundColor:
                          location?.pathname == item.link
                            ? "#e8f2fe"
                            : "transparent",
                        cursor: "pointer",
                      }}
                    >
                      <ListItemIcon>
                        <img
                          src={item.image}
                          width={10}
                          className="custom-img"
                        />
                      </ListItemIcon>

                      <ListItemText
                        className={
                          language == "ar" ? "sidebarText2" : "sidebarText"
                        }
                        style={{
                          textAlign: language != "ar" ? "left" : "right",
                          fontSize: language == "ar" ? "20px" : "14px",
                        }}
                        primary={item.title}
                      />
                    </ListItem>
                    // <div
                    //       className="linkBox nav-hover"
                    //       style={{
                    //         backgroundColor:
                    //           location?.pathname == item.link
                    //             ? "#e8f2fe"
                    //             : "transparent",
                    //         paddingTop: 4,
                    //         paddingBottom: 4,
                    //         display: "flex",
                    //         justifyContent: "center",
                    //         alignItems: "center",
                    //         textAlign: "center",
                    //         flexDirection: "column",
                    //         fontSize: "10px",
                    //         cursor: "pointer",
                    //       }}
                    //       onClick={() => {
                    //         setShowChild(item.title);
                    //         history.push(item.link);
                    //       }}
                    //     >
                    //       <div style={{ alignItems: "center" }}>
                    //         <img src={item.image} className="custom-img" />
                    //       </div>
                    //       {window.innerWidth > 500 && (
                    //         <p className="navLable" style={{ fontWeight: "bold" }}>
                    //           {item.title}
                    //         </p>
                    //       )}{" "}
                    //     </div>
                  );
                }
              }
            } else if (packageDetails?.package?.title == "Enterprise") {
              return (
                <ListItem
                  button
                  disableRipple={true}
                  disableTouchRipple={true}
                  key={item.title}
                  className="linkBox nav-hover"
                  onClick={() => {
                    setShowChild(item.title);
                    history.push(item.link);
                  }}
                  style={{
                    paddingTop: "7px",
                    paddingBottom: "7px",

                    backgroundColor:
                      location?.pathname == item.link
                        ? "#e8f2fe"
                        : "transparent",
                    cursor: "pointer",
                  }}
                >
                  <ListItemIcon>
                    <img src={item.image} width={10} className="custom-img" />
                  </ListItemIcon>

                  <ListItemText
                    className={
                      language == "ar" ? "sidebarText2" : "sidebarText"
                    }
                    style={{
                      textAlign: language != "ar" ? "left" : "right",
                      fontSize: language == "ar" ? "20px" : "14px",
                    }}
                    primary={item.title}
                  />
                </ListItem>
                // <div
                //       className="linkBox nav-hover"
                //       style={{
                //         backgroundColor:
                //           location?.pathname == item.link
                //             ? "#e8f2fe"
                //             : "transparent",
                //         paddingTop: 4,
                //         paddingBottom: 4,
                //         display: "flex",
                //         justifyContent: "center",
                //         alignItems: "center",
                //         textAlign: "center",
                //         flexDirection: "column",
                //         fontSize: "10px",
                //         cursor: "pointer",
                //       }}
                //       onClick={() => {
                //         setShowChild(item.title);
                //         history.push(item.link);
                //       }}
                //     >
                //       <div style={{ alignItems: "center" }}>
                //         <img src={item.image} className="custom-img" />
                //       </div>
                //       {window.innerWidth > 500 && (
                //         <p className="navLable" style={{ fontWeight: "bold" }}>
                //           {item.title}
                //         </p>
                //       )}{" "}
                //     </div>
              );
            }
          })}{" "}
        </>
      )}

      {window.innerWidth > 500 && (
        <>
          {packageDetails?.package?.title == "Enterprise" ? (
            <>
              {company?.role !== "inspector" && company?.role !== "management" && (
                <ListItem
                  button
                  disableRipple={true}
                  disableTouchRipple={true}
                  key={"Settings"}
                  className="linkBox nav-hover"
                  onClick={() => dispatch(openSideBar())}
                  style={{
                    paddingTop: "7px",
                    paddingBottom: "7px",

                    backgroundColor:
                      location?.pathname == "/company" ||
                      location?.pathname == "/team" ||
                      location?.pathname == "/site" ||
                      location?.pathname == "/company" ||
                      location?.pathname == "/workflow"
                        ? "#e8f2fe"
                        : "transparent",
                    cursor: "pointer",
                  }}
                >
                  <ListItemIcon>
                    <img src={more} width={10} className="custom-img" />
                  </ListItemIcon>

                  <ListItemText
                    className={
                      language == "ar" ? "sidebarText2" : "sidebarText"
                    }
                    style={{
                      textAlign: language != "ar" ? "left" : "right",
                      fontSize: language == "ar" ? "20px" : "14px",
                    }}
                    primary={<>{t("Settings")}</>}
                  />
                </ListItem>
              )}

              {company?.role !== "inspector" && (
                <ListItem
                  disableRipple={true}
                  disableTouchRipple={true}
                  button
                  key={"upgrade Package"}
                  className="linkBox nav-hover"
                  onClick={() => {
                    setShowChild("upgrade Package");
                    history.push("/update_package");
                  }}
                  style={{
                    paddingTop: "7px",
                    paddingBottom: "7px",

                    backgroundColor:
                      location?.pathname == "/update_package"
                        ? "#e8f2fe"
                        : "transparent",
                    cursor: "pointer",
                  }}
                >
                  <ListItemIcon>
                    <img src={buy} width={10} className="custom-img" />
                  </ListItemIcon>

                  <ListItemText
                    className={
                      language == "ar" ? "sidebarText2" : "sidebarText"
                    }
                    style={{
                      textAlign: language != "ar" ? "left" : "right",
                      fontSize: language == "ar" ? "20px" : "14px",
                    }}
                    primary={<>{t("Packages")}</>}
                  />
                </ListItem>
              )}
            </>
          ) : (
            <>
              <ListItem
                button
                disableRipple={true}
                disableTouchRipple={true}
                key={"Settings"}
                className="linkBox nav-hover"
                onClick={() => dispatch(openSideBar())}
                style={{
                  paddingTop: "7px",
                  paddingBottom: "7px",

                  backgroundColor:
                    location?.pathname == "/company" ||
                    location?.pathname == "/team" ||
                    location?.pathname == "/site" ||
                    location?.pathname == "/company" ||
                    location?.pathname == "/workflow"
                      ? "#e8f2fe"
                      : "transparent",
                  cursor: "pointer",
                }}
              >
                <ListItemIcon>
                  <img src={more} width={10} className="custom-img" />
                </ListItemIcon>

                <ListItemText
                  className={language == "ar" ? "sidebarText2" : "sidebarText"}
                  style={{
                    textAlign: language != "ar" ? "left" : "right",
                    fontSize: language == "ar" ? "20px" : "14px",
                  }}
                  primary={t("Settings")}
                />
              </ListItem>

              <ListItem
                button
                disableRipple={true}
                disableTouchRipple={true}
                key={"upgrade Package"}
                className="linkBox nav-hover"
                onClick={() => {
                  setShowChild("upgrade Package");
                  history.push("/update_package");
                }}
                style={{
                  paddingTop: "7px",
                  paddingBottom: "7px",

                  backgroundColor:
                    location?.pathname == "/update_package"
                      ? "#e8f2fe"
                      : "transparent",
                  cursor: "pointer",
                }}
              >
                <ListItemIcon>
                  <img src={buy} width={10} className="custom-img" />
                </ListItemIcon>

                <ListItemText
                  className={language == "ar" ? "sidebarText2" : "sidebarText"}
                  style={{
                    textAlign: language != "ar" ? "left" : "right",
                    fontSize: language == "ar" ? "20px" : "14px",
                  }}
                  primary={<>{t("Packages")}</>}
                />
              </ListItem>
            </>
          )}

          <a
            href="https://www.uraudits.com/knowledge-center-login/"
            target="_blank"
          >
            <ListItem
              button
              disableRipple={true}
              disableTouchRipple={true}
              key={"Help Center"}
              className="linkBox nav-hover"
              style={{
                paddingTop: "7px",
                paddingBottom: "7px",

                backgroundColor: "transparent",
                cursor: "pointer",
              }}
            >
              <ListItemIcon>
                <img src={help} width={10} className="custom-img" />
              </ListItemIcon>
              <ListItemText
                className={language == "ar" ? "sidebarText2" : "sidebarText"}
                style={{
                  textAlign: language != "ar" ? "left" : "right",
                  fontSize: language == "ar" ? "20px" : "14px",
                }}
                primary={<>{t("Help Center")}</>}
              />
            </ListItem>
          </a>
        </>
      )}

      {window.innerWidth <= 500 && (
        <>
          {packageDetails?.package?.title == "Enterprise" ? (
            <>
              {company?.role !== "inspector" && company?.role !== "management" && (
                <div
                  style={{
                    color: "white",
                    height: "70px",
                    paddingTop: 4,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    flexDirection: "column",
                    fontSize: "8px",
                    fontWeight: "500px",
                    cursor: "pointer",
                  }}
                  className="nav-hover"
                  onClick={() => dispatch(openSideBar())}
                >
                  <div style={{ alignItems: "center" }}>
                    <img src={more} className="custom-img" />
                  </div>
                  {window.innerWidth > 500 && (
                    <p
                      className="navLable"
                      style={{
                        marginTop: "1px",
                        color: "black",
                        fontWeight: "bold",
                        fontSize: language == "ar" ? "20px" : "14px",
                      }}
                    >
                      <>{t("Settings")}</>
                    </p>
                  )}
                </div>
              )}

              {company?.role !== "inspector" && (
                <div
                  style={{
                    color: "white",
                    height: "70px",
                    paddingTop: 4,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    flexDirection: "column",
                    fontSize: language == "ar" ? "20px" : "14px",
                    fontWeight: "500px",
                    cursor: "pointer",
                  }}
                  className="nav-hover"
                  onClick={() => {
                    setShowChild("upgrade Package");
                    history.push("/update_package");
                  }}
                >
                  {/* onClick={() => dispatch(openSideBar())} */}
                  <div style={{ alignItems: "center" }}>
                    <img src={buy} className="custom-img" />
                  </div>
                  {window.innerWidth > 500 && (
                    <p
                      className="navLable"
                      style={{
                        marginTop: "1px",
                        color: "black",
                        fontWeight: "bold",
                        fontSize: language == "ar" ? "20px" : "14px",
                      }}
                    >
                      <>{t("Upgrade Package")}</>
                    </p>
                  )}
                </div>
              )}
            </>
          ) : (
            <>
              <div
                style={{
                  color: "white",
                  height: "70px",
                  paddingTop: 4,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  flexDirection: "column",
                  fontSize: language == "ar" ? "20px" : "14px",
                  fontWeight: "500px",
                  cursor: "pointer",
                }}
                className="nav-hover"
                onClick={() => dispatch(openSideBar())}
              >
                <div style={{ alignItems: "center" }}>
                  <img src={more} className="custom-img" />
                </div>
                {window.innerWidth > 500 && (
                  <p
                    className="navLable"
                    style={{
                      marginTop: "1px",
                      color: "black",
                      fontWeight: "bold",
                      fontSize: language == "ar" ? "20px" : "14px",
                    }}
                  >
                    <>{t("Settings")}</>
                  </p>
                )}
              </div>

              <div
                style={{
                  color: "white",
                  height: "70px",
                  paddingTop: 4,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  flexDirection: "column",
                  fontSize: language == "ar" ? "20px" : "14px",
                  fontWeight: "500px",
                  cursor: "pointer",
                }}
                className="nav-hover"
                onClick={() => {
                  setShowChild("upgrade Package");
                  history.push("/update_package");
                }}
              >
                {/* onClick={() => dispatch(openSideBar())} */}
                <div style={{ alignItems: "center" }}>
                  <img src={buy} className="custom-img" />
                </div>
                {window.innerWidth > 500 && (
                  <p
                    className="navLable"
                    style={{
                      marginTop: "1px",
                      color: "black",
                      fontWeight: "bold",
                      fontSize: language == "ar" ? "20px" : "14px",
                    }}
                  >
                    <>{t("Upgrade Package")}</>
                  </p>
                )}
              </div>
            </>
          )}
        </>
      )}
    </List>
  );
};

export default SideBar;
